import { MenuItem } from 'vue-graphql-models';

export default [

  new MenuItem({
    id: 'createNewMaterial',
    title: 'Create New Material',
    subtitle: 'Add New Material',
    route: { name: 'createNewMaterial' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'materialHelp',
    title: 'Help',
    subtitle: 'How to\'s and Contact Info',
    customIcon: true,
    icon: 'dhc-help',
  }),
  new MenuItem({
    id: 'materialEdit',
    title: 'Edit Material',
    subtitle: 'Edit Material Details',
    route: { name: 'materialEdit' },
    customIcon: true,
    icon: 'dhc-pencil-s',
  }),
  new MenuItem({
    id: 'materialDelete',
    title: 'Delete Material',
    subtitle: 'Remove Material Record',
    route: { name: 'contactForm' },
    customIcon: true,
    icon: 'dhc-trash',
  }),
  new MenuItem({
    id: 'materialClone',
    title: 'Clone Material',
    subtitle: 'Clone Material Details',
    route: { name: 'materials' },
    customIcon: true,
    icon: 'dhc-new',
  }),
  new MenuItem({
    id: 'materialAddNotes',
    title: 'Add Notes',
    subtitle: 'Add new notes',
    route: { name: 'materials' },
    customIcon: true,
    icon: 'dhc-file-text',
  }),
];
